import { create } from 'zustand';

export interface BaseInfoData {
  /** 名称 */
  name?: string;
  /** 别名 */
  alias?: string;
  /** 命名空间 */
  namespace?: string;
  /** 描述 */
  annotations?: string;
}

interface BaseInfoState {
  baseInfo: BaseInfoData;
  validateBaseInfo?: () => Promise<boolean>;
}

const initBaseInfo: BaseInfoState = {
  baseInfo: {
    name: undefined,
    alias: undefined,
    namespace: undefined,
    annotations: undefined,
  },
};

interface BaseInfoAction {
  /** 更新基础信息 */
  updateBaseInfo: (baseInfo: BaseInfoData) => void;
  setValidate: (validate: () => Promise<boolean>) => void;
  /** 重置 */
  reset: () => void;
}

export const useBaseInfoStore = create<BaseInfoState & BaseInfoAction>()((set) => ({
  ...initBaseInfo,
  updateBaseInfo: (baseInfo) => set({ baseInfo }),
  setValidate: (validate: () => Promise<boolean>) => set({ validateBaseInfo: validate }),
  reset: () => set(initBaseInfo),
}));
